import api from '@/apis/di/inventoryItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useInventoryItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onInventoryItemComboboxLoadData = (payload, row, column) => {
    payload.sort = 'inventory_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];

    payload.filter = extendFilter(payload.filter, extend);

    if (payload.columns && !payload.columns.includes('sale_account')) {
      payload.columns += ',sale_account';
    }
    // tk chi phí
    if (payload.columns && !payload.columns.includes('cost_account')) {
      payload.columns += ',cost_account';
    }
    if (payload.columns && !payload.columns.includes('inventory_account')) {
      payload.columns += ',inventory_account';
    }
    // đơn vị tính
    if (payload.columns && !payload.columns.includes('unit')) {
      payload.columns += ',unit';
    }
    // diễn giải
    if (payload.columns && !payload.columns.includes('description')) {
      payload.columns += ',description';
    }
    if (payload.columns && !payload.columns.includes('default_stock_id')) {
      payload.columns += ',default_stock_id';
    }
    if (payload.columns && !payload.columns.includes('default_stock_name')) {
      payload.columns += ',default_stock_name';
    }
    // đơn giá mua
    if (payload.columns && !payload.columns.includes('unit_price')) {
      payload.columns += ',unit_price';
    }
    // tỷ lệ quy đổi
    if (payload.columns && !payload.columns.includes('convert_rate')) {
      payload.columns += ',convert_rate';
    }
    if (payload.columns && !payload.columns.includes('tax_rate')) {
      payload.columns += ',tax_rate';
    }
    // đối tượng
    if (payload.columns && !payload.columns.includes('accounting_object_id')) {
      payload.columns += ',accounting_object_id';
    }
    // if (payload.columns && !payload.columns.includes('accounting_object_name')) {
    //   payload.columns += ',accounting_object_name';
    // }
    // đơn giá bán
    if (payload.columns && !payload.columns.includes('sale_price')) {
      payload.columns += ',sale_price';
    }
    // là dịch vụ
    if (payload.columns && !payload.columns.includes('is_service')) {
      payload.columns += ',is_service';
    }
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // func call api lấy dữ liệu combo custom không lấy dịch vụ
  const onInventoryItemNotServiceComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'is_service', Operator: 'NULL' }];
    let extend = [{ Field: 'is_service', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);

    onInventoryItemComboboxLoadData(payload, row, column);
  };

  // config columns combo
  const inventoryItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {

        title: 'Mã VTHH',
        dataField: 'inventory_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên VTHH',
        dataField: 'inventory_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'inventory_item_code',
    valueField: 'inventory_item_id',
    quickAddMulti: [
      {
        valueField: 'InventoryDetail',
        displayField: 'Vật tư hàng hóa',
      },
      {
        valueField: 'ToolDetail',
        displayField: 'Công cụ dụng cụ',
      },
    ],
    queryMode: 'remote',
    getModelData: getModelData,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'VTHH',
      payload: {
        sort: 'inventory_item_code,stock_code',
        filter: [{ Field: 'inactive', Value: false, Ors: [{ Field: 'inactive', Operator: 'NULL' }] }],
      },
      module: 'inventoryItemQuickSearch',
      idField: 'key_id',
      QuickSearchColumns: [
        {
          tooltip: 'Mã vật tư hàng hóa',
          title: 'Mã VTHH',
          dataField: 'inventory_item_code',
          width: 100,
          filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
        },
        {
          tooltip: 'Tên vật tư hàng hóa',
          title: 'Tên VTHH',
          dataField: 'inventory_item_name',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          width: 400,
        },
        {
          title: 'Mã kho',
          dataField: 'stock_code',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          width: 100,
        },
        {
          title: 'Số lượng tồn',
          dataField: 'total_inventory_by_stock',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          formatType: proxy.$ms.constant.FormatType.Quantity,
          width: 100,
        },
      ],
    },

    dropdownWidth: 600,
    comboboxLoadData: onInventoryItemComboboxLoadData,
  };

  /**
   * Thực hiện validate data trước khi thêm nhanh vào cell
   * @param {*} record
   * NVTUAN1 12.09.2022
   */
  function validateQuickAddInventoryNotService(record) {
    return !record.is_service;
  }

  function getModelData() {
    if (proxy.getModelDataDetail && typeof proxy.getModelDataDetail === 'function') {
      return proxy.getModelDataDetail();
    }
  }

  // config columns combo cho combobox VTHH không lấy dịch vụ
  const inventoryItemNotServiceComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã VTHH',
        dataField: 'inventory_item_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên VTHH',
        dataField: 'inventory_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'inventory_item_code',
    valueField: 'inventory_item_id',
    quickAddMulti: [
      { valueField: 'InventoryDetail', displayField: 'Vật tư hàng hóa' },
      { valueField: 'ToolDetail', displayField: 'Công cụ dụng cụ' },
    ],
    validateQuickAdd: validateQuickAddInventoryNotService,
    getModelData: getModelData,
    queryMode: 'remote',
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'VTHH',
      payload: {
        sort: 'inventory_item_code,stock_code',
        filter: [
          { Field: 'inactive', Value: false, Ors: [{ Field: 'inactive', Operator: 'NULL' }] },
          { Field: 'is_service', Value: false, Ors: [{ Field: 'is_service', Operator: 'NULL' }] },
        ],
      },
      module: 'inventoryItemQuickSearch',
      idField: 'key_id',
      QuickSearchColumns: [
        {
          tooltip: 'Mã vật tư hàng hóa',
          title: 'Mã VTHH',
          dataField: 'inventory_item_code',
          width: 100,
          filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
        },
        {
          tooltip: 'Tên vật tư hàng hóa',
          title: 'Tên VTHH',
          dataField: 'inventory_item_name',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          width: 400,
        },
        {
          title: 'Mã kho',
          dataField: 'stock_code',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          width: 100,
        },
        {
          title: 'Số lượng tồn',
          dataField: 'total_inventory_by_stock',
          filterOperator: proxy.$ms.constant.FilterOperator.Contains,
          formatType: proxy.$ms.constant.FormatType.Quantity,
          width: 100,
        },
      ],
    },
    dropdownWidth: 600,
    comboboxLoadData: onInventoryItemNotServiceComboboxLoadData,
  };

  /**
   * Lấy danh mục công cụ dụng cụ
   * HQMINH 12.07.2022
   */
  const onInventoryItemToolComboboxLoadData = (payload, row, column) => {
    payload.sort = 'inventory_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_tool', Value: true },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    // đơn vị tính
    if (payload.columns && !payload.columns.includes('unit')) {
      payload.columns += ',unit';
    }
    if (payload.columns && !payload.columns.includes('convert_unit')) {
      payload.columns += ',convert_unit';
    }
    // tk chi phí
    if (payload.columns && !payload.columns.includes('convert_rate')) {
      payload.columns += ',convert_rate';
    }
    if (payload.columns && !payload.columns.includes('unit_price')) {
      payload.columns += ',unit_price';
    }

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  /**
   * Lấy danh mục công cụ dụng cụ
   * HQMINH 12.07.2022
   */
  const inventoryItemToolComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CCDC',
        dataField: 'inventory_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CCDC',
        dataField: 'inventory_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'inventory_item_code',
    valueField: 'inventory_item_id',
    quickAdd: 'ToolDetail',
    queryMode: 'remote',
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'CCDC',
      payload: {
        columns: ['inventory_item_code', 'inventory_item_name', 'inventory_item_id', 'unit_price', 'unit'],
        sort: 'inventory_item_code',
        filter: [
          { Field: 'inactive', Value: false, Ors: [{ Field: 'inactive', Operator: 'NULL' }] },
          { Field: 'is_tool', Value: true },
        ],
      },
      module: 'inventoryItem',
      idField: 'inventory_item_id',
    },
    dropdownWidth: 600,
    comboboxLoadData: onInventoryItemToolComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    inventoryItemComboConfig,
    inventoryItemNotServiceComboConfig,
    inventoryItemToolComboConfig,
    onInventoryItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
